/**
 * Created by saltrichter on 7/10/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/notificationTab/NotificationListView.tmpl"),
        NotificationListItemView = require("connection-views/notificationTab/NotificationListItemView"),
        NotificationListEmptyView = require("connection-views/notificationTab/NotificationListEmptyView"),
        NotificationListView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        NotificationListView = Marionette.CompositeView.extend({
            template: template,
            className: 'notification-list-wrapper',
            itemViewContainer: ".notification-list-container",
            itemView: NotificationListItemView,
            emptyView: NotificationListEmptyView,

            initialize: function () {
                this.listenTo(this.collection, "change:isDeleted", this.checkEmpty, this);
                this.listenTo(this.collection, "sort", this.render, this);
            },

            setSelected: function (id) {
                this.children.each(function (view) {
                    if (view.setSelected) {
                        view.setSelected(id);
                    }
                });
            },

            isEmpty: function (collection) {
                return !collection.find(function (model) {
                    return !model.isDeleted();
                });
            }
        });
    });
    return NotificationListView;
});
